// imports
import React, { useState, useEffect } from "react";
import "./blog.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditorToolbar, {
  modules,
  formats,
} from "../../../Components/EditorToolbar";
import axios from "axios";
import { FaTrash, FaEdit } from "react-icons/fa";
import { IoChevronDown, IoChevronForwardSharp } from "react-icons/io5";
import "react-toastify/dist/ReactToastify.css";
import { API_Local } from "../../../server";
import { toast } from "react-toastify";
import Select from "react-select";
import { Store } from "../../../Redux/store";
import { actionButtonLoader } from "../../../Redux/Actions/buttonClicks";
import { getBlogData } from "../../../Redux/Actions/dataResponse";
import { useSelector } from "react-redux";
import { IoIosAddCircleOutline, IoMdArrowRoundBack } from "react-icons/io";
import ButtonPagenate from "../../../Components/ButtonPagenate/ButtonPagenate";

// endpoints for fetching, creating, deleting and editing blog posts
const Blog = ({ sendnotice }) => {
  const API_FETCH = `${API_Local}/blog/fetch`;
  const API_CREATE = `${API_Local}/blog/create`;
  const API_DELETE = `${API_Local}/blog/delete`;
  const API_EDIT = `${API_Local}/blog/edit`;

  // state variables management
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [title, setTitle] = useState("");
  const [value, setValue] = useState("Obaloluwa");
  const [caption, setCaption] = useState("");
  const [category, setCategory] = useState("news");
  const [buttonlabel, setbuttonlabel] = useState("");
  const [previewclick, setPreviewclick] = useState(false);
  const [previewImage, setPreviewImage] = useState(false);
  const [useExistingImage, setUseExistingImage] = useState(true);
  const [imageUrl, setImageUrl] = useState("");
  const [disable, setDisable] = useState(false);
  const [selectedOption, setSelectedOption] = useState("News");
  const [tab, setTab] = useState("blog");
  const [pageNumber, setPageNumber] = useState(0);

  const { blogdata } = useSelector((state) => state.userdata);

  const itemsPerpage = 5; //Number of items to be displayed per page
  const pageCount = Math.ceil(blogdata.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;

  const newPagenum = (num) => {
    setPageNumber(num);
  };

  useEffect(() => {
    fetchBlogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // async function to fetch blog posts from the server
  const fetchBlogs = async () => {
    Store.dispatch(
      actionButtonLoader({
        status: 1,
        message: "Fetching blog data ...",
        icon: 0,
      })
    );

    try {
      const response = await axios.get(API_FETCH);
      // console.log(response);
      if (response.data.success) {
        Store.dispatch(getBlogData(response.data.data));
        Store.dispatch(
          actionButtonLoader({
            status: 0,
            message: "",
            icon: 0,
          })
        );
      }
    } catch (error) {
      Store.dispatch(
        actionButtonLoader({
          status: 0,
          message: "",
          icon: 0,
        })
      );
    }
  };

  // async function to submit form: uploads image to google drive and gets url
  const handleSubmit = async (e) => {
    e.preventDefault();
    Store.dispatch(
      actionButtonLoader({
        status: 1,
        message: "Submitting blog data ...",
        icon: 0,
      })
    );

    const blogPost = {
      title,
      value,
      caption,
      category,
      buttonlabel,
      imageurl: imageUrl,
    };

    try {
      const response = isEditing
        ? await axios.post(`${API_EDIT}/${currentId}`, blogPost)
        : await axios.post(API_CREATE, blogPost);

      if (response.data.success) {
        Store.dispatch(
          actionButtonLoader({
            status: 0,
            message: "",
            icon: 0,
          })
        );
        toast.success(response.data.msg);
        Store.dispatch(getBlogData(response.data.data));

        // setBlogs(response.data.data);
        setShowForm(false);
        setIsEditing(false);
        setCurrentId(null);
      }
    } catch (e) {
      // toast.error(e.response.data.msg);
      Store.dispatch(
        actionButtonLoader({
          status: 0,
          message: "",
          icon: 0,
        })
      );
    }
  };

  // sends a DELETE request and updates blogs variable
  const handleDelete = async (id) => {
    Store.dispatch(
      actionButtonLoader({
        status: 1,
        message: "Removing blog data...",
        icon: 0,
      })
    );

    try {
      const response = await axios.delete(`${API_DELETE}/${id}`);
      if (response.data.success) {
        toast.success(response.data.msg);
        Store.dispatch(
          actionButtonLoader({
            status: 0,
            message: "",
            icon: 0,
          })
        );
        Store.dispatch(getBlogData(response.data.data));
      }
    } catch (e) {
      toast.error(e.response.message);
    }
  };

  // sets the state of the form input values and toggles the form visibility
  const handleEdit = (blog) => {
    console.log(blog);
    setValue(blog.text);
    setTitle(blog.title);
    setCaption(blog.caption);
    setbuttonlabel(blog.buttonlabel);
    setCategory(blog.category);
    setCurrentId(blog.id);
    setImageUrl(blog.imageurl);
    setIsEditing(true);
    setShowForm(true);
    setUseExistingImage(true);
  };

  // shows/hides the blog post preview
  const handlePreviewClick = () => {
    setPreviewclick(!previewclick);
  };

  const handleFileChange = async (e) => {
    setDisable(true);

    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(`${API_Local}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setDisable(false);
      setImageUrl(response.data.fileUrl);
      setPreviewImage(true);
    } catch (error) {
      setDisable(false);
      console.error("Error uploading file:", error);
    }
  };

  const options = [
    { value: "blog", label: "Blog" },
    { value: "news", label: "News" },
  ];

  const handleTabselect = (props) => {
    setTab(props);
  };

  const handleShowform = (props) => {
    if (props === "back") {
      setValue("");
      setTitle("");
      setCaption("");
      setbuttonlabel("");
      setCategory("");
      setCurrentId("");
      setImageUrl("");
      setShowForm(false);
      setIsEditing(false);
    } else {
      setShowForm(true);
    }
  };

  const handleSelect = (props) => {
    setSelectedOption(props.label);
    setCategory(props.value);
  };

  return (
    <div className="blog-admin-container">
      <div
        className={`w-full flex items-center ${
          !showForm ? "justify-between" : "justify-end"
        } gap-1 bg-custom-radial`}
      >
        {!showForm && (
          <div className="flex items-center gap-2">
            <div
              className={`py-3 px-10 h-full ${
                tab === "blog"
                  ? "bg-[blue] text-[white] hover:bg-[#0000ff82]"
                  : "hover:bg-[#0000ff0a]"
              } hover:shadow-md cursor-pointer  items-center justify-start gap-2`}
              onClick={() => handleTabselect("blog")}
            >
              Blog
            </div>

            <div
              className={`py-3 px-10 h-full items-center ${
                tab === "news"
                  ? "bg-[blue] text-[white] hover:bg-[#0000ff82]"
                  : "hover:bg-[#0000ff0a]"
              } justify-start gap-2 cursor-pointer hover:shadow-md`}
              onClick={() => handleTabselect("news")}
            >
              News
            </div>
          </div>
        )}

        {showForm && (
          <div
            className="py-3 flex items-center gap-2 bg-[green] h-full px-4 cursor-pointer hover:shadow-md"
            onClick={() => handleShowform("back")}
          >
            <IoMdArrowRoundBack color="white" size={20} />
            <span className="text-[white]">Back</span>
          </div>
        )}

        {!showForm && (
          <div
            className="py-3 flex items-center gap-2 bg-[blue] h-full px-4 cursor-pointer hover:shadow-md"
            onClick={() => handleShowform("new")}
          >
            <IoIosAddCircleOutline color="white" size={20} />
            <span className="text-[white]">New Feed</span>
          </div>
        )}
      </div>

      {showForm ? (
        <div>
          <div className="blog-admin-title">
            <span>{isEditing ? "EDIT BLOG POST" : "ADD NEW BLOG POST"}</span>
          </div>

          <form onSubmit={handleSubmit} className="blog-admin-body">
            <div className="blog-admin-body-row w-[50%] min-w-[300px]">
              <span>Title: </span>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter blog title"
                className="w-full min-w-[150px] text-[12px] rounded-sm grow"
              />
            </div>

            <div className="blog-admin-body-row w-[50%] min-w-[300px]">
              <span>Category: </span>
              <Select
                options={options}
                defaultValue={selectedOption}
                onChange={handleSelect}
                placeholder="Category"
                className="w-full min-w-[150px] text-[12px] rounded-sm grow"
              />
            </div>

            <div className="blog-admin-body-row w-[50%] min-w-[300px]">
              <span>Caption: </span>

              <textarea
                rows={5}
                cols={35}
                placeholder="Enter blog caption"
                className="w-full min-w-[150px] text-[12px] rounded-sm grow"
                value={caption}
                onChange={(e) => setCaption(e.target.value)}
              />
            </div>

            <div className="blog-admin-body-row w-[50%] min-w-[300px]">
              <span>Button Label: </span>
              <input
                type="text"
                value={buttonlabel}
                onChange={(e) => setbuttonlabel(e.target.value)}
                placeholder="Enter button label"
                className="w-full min-w-[150px] text-[12px] rounded-sm grow"
              />
            </div>

            <div className="blog-admin-body-row w-full min-w-[300px]">
              <span>Text: </span>
              <div id="blog-text-area">
                <EditorToolbar toolbarId={"t2"} />
                <ReactQuill
                  theme="snow"
                  value={value}
                  onChange={(content) => setValue(content)}
                  modules={modules("t2")}
                  className="w-full min-h-[200px] overflow-y-auto"
                  formats={formats}
                />
              </div>
            </div>

            {isEditing ? (
              <div className="blog-admin-body-row w-[50%] min-w-[300px]">
                <span>Image: </span>
                <div>
                  <label className="flex gap-2 items-center">
                    <input
                      type="radio"
                      checked={useExistingImage}
                      onChange={() => setUseExistingImage(true)}
                    />
                    Continue with existing image
                  </label>
                </div>

                <div className="flex gap-2 items-center">
                  <label className="flex gap-2 items-center">
                    <input
                      type="radio"
                      checked={!useExistingImage}
                      onChange={() => setUseExistingImage(false)}
                    />
                    Upload a new image
                  </label>

                  {!useExistingImage && (
                    <div className="image-upload-container">
                      <div
                        id="agencynames_ss"
                        className="flex items-center justify-center"
                      >
                        <input
                          disabled={disable ? true : false}
                          type="file"
                          name="avatar"
                          id="file-input"
                          accept=".jpg, .jpeg, .png, .webp"
                          onChange={handleFileChange}
                          className=""
                        />

                        {previewImage && (
                          <div className="image-preview">
                            <img
                              src={imageUrl}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "80px",
                                borderRadius: "10px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="blog-admin-body-row">
                <span>Image: </span>
                <div className="image-upload-container">
                  <div id="agencynames_ss">
                    <input
                      disabled={disable ? true : false}
                      type="file"
                      name="avatar"
                      id="file-input"
                      accept=".jpg, .jpeg, .png, .webp"
                      onChange={handleFileChange}
                      className="sr-only group relative w-full h-[40px] flex justify-center py-2 px-4 text-sm font-medium rounded-md text-white cursor-pointer"
                    />
                  </div>
                  {previewImage && (
                    <div className="image-preview">
                      <img
                        src={imageUrl}
                        alt="Preview"
                        style={{
                          width: "100px",
                          height: "80px",
                          borderRadius: "10px",
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="blog-admin-body-row">
              <button
                disabled={disable ? true : false}
                className={`${
                  !disable
                    ? "bg-[#e85000] cursor-pointer"
                    : "bg-[#80808080] cursor-not-allowed"
                }`}
                type="submit"
              >
                {isEditing ? "Update" : "Submit"}
              </button>
            </div>

            <div className="website-preview-container">
              <div className="website-preview" onClick={handlePreviewClick}>
                <span>Web Preview</span>
                {previewclick ? (
                  <IoChevronDown
                    id="chevron-down"
                    onClick={handlePreviewClick}
                  />
                ) : (
                  <IoChevronForwardSharp
                    id="chevron-down"
                    onClick={handlePreviewClick}
                  />
                )}
              </div>

              <div className="ql-editor">
                <div
                  className={
                    previewclick === false
                      ? "website-preview-body"
                      : "website-preview-bdy"
                  }
                  dangerouslySetInnerHTML={{ __html: value }}
                />
              </div>
            </div>
          </form>
        </div>
      ) : (
        <div>
          <h1 className="blogpost-title">
            {tab === "blog" ? "BLOG POSTS" : "NEWS INSIGHTS"}
          </h1>
          <div className="flex-wrap flex w-full gap-2 ">
            {blogdata.length > 0 ? (
              blogdata
                .filter((items) => items.category === tab)
                .slice(pagesVisited, pagesVisited + itemsPerpage)
                .map((blog) => (
                  <div
                    key={blog.id}
                    className="blog-post grow-1 max-w-[500px] min-w-[300px] cursor-pointer hover:shadow-md"
                  >
                    <div className=" flex flex-col gap-3">
                      <h2>{blog.title}</h2>
                      <div>{blog.caption}</div>
                      <img
                        className="w-full max-w-[500px] h-[25%] min-w-[280px] min-h-[150px]"
                        alt="preview"
                        src={blog.imageurl}
                      />
                      <div dangerouslySetInnerHTML={{ __html: blog.image }} />

                      <div className="flex items-center gap-3">
                        <button
                          className="rounded-full p-2 hover:bg-[#8080804a] cursor-pointer"
                          onClick={() => handleEdit(blog)}
                        >
                          <FaEdit
                            size={18}
                            className="text-[blue] hover:text-[#333]"
                          />
                        </button>

                        <button
                          className="rounded-full p-2 hover:bg-[#8080804a] cursor-pointer i"
                          onClick={() => handleDelete(blog.id)}
                        >
                          <FaTrash
                            size={14}
                            className="text-[red] hover:text-[#333]"
                          />
                        </button>

                        <span className="bg-[#80808010] text-[12px] text-[#333] px-5 py-1 rounded-lg shadow-sm">
                          {tab === "blog" ? "Blog" : "News"}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <p>Checking for available blog post...</p>
            )}

            <div className="flex items-center w-full justify-center">
              <ButtonPagenate
                updatedPageNum={newPagenum}
                pageCount={pageCount}
                pageNumber={pageNumber}
                previousLabel="Prev"
                nextLabel="Next"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Blog;
